<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'CANALES.LBL_CANALES' | translate}}</h1>
  </div>
</div>
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6">
          <button type="button" pButton icon="fa fa-plus" (click)="crearCanal()" *ngIf="menu.agregar"
                  label="{{ 'BTN_AGREGAR' | translate}}"></button>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                 (input)="dt.filterGlobal($event.target.value, 'contains')"
                 [(ngModel)]="busqueda" (change)="setBusqueda()">
        </div>
      </div>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" [loading]="carCanales" #dt
                   [value]="canales" selectionMode="single" dataKey="idCanal"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.codigo}}</td>
                <td>{{row.nombre}}</td>
                <td>{{row.nombreTipoCanal}}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                            title="{{'BTN_VISUALIZAR' | translate}}"
                            pButton (click)="verCanal(row)"></button>
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                            title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                            (click)="editarCanal(row)"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
